import { z } from 'zod'

import {
	ROUTINE_TEST_NAME_OPTIONS,
	TEST_FREQUENCY_OPTIONS,
} from '#app/routes/mocra+/_form+/components/test-routines/constants.ts'

const ROUTINE_TEST_NAME_VALUE_SET = new Set(
	ROUTINE_TEST_NAME_OPTIONS.map((option) => option.value),
)

const TEST_FREQUENCY_VALUE_SET = new Set(
	TEST_FREQUENCY_OPTIONS.map((option) => option.value),
)

export const TestRoutineEntrySchema = z
	.preprocess(
		(input) => {
			if (!input || typeof input !== 'object') return input
			const record = { ...(input as Record<string, unknown>) }
			const rawName = record.name
			const rawOther =
				typeof record.nameOther === 'string'
					? record.nameOther.trim()
					: undefined
			if (typeof rawName === 'string') {
				const trimmed = rawName.trim()
				const isKnown = ROUTINE_TEST_NAME_VALUE_SET.has(trimmed)
				if (!isKnown && trimmed.length > 0) {
					return {
						...record,
						name: 'other',
						nameOther: rawOther && rawOther.length > 0 ? rawOther : trimmed,
					}
				}
				return {
					...record,
					nameOther:
						trimmed === 'other' && rawOther && rawOther.length > 0
							? rawOther
							: undefined,
				}
			}
			return record
		},
		z.object({
			name: z.enum(
				ROUTINE_TEST_NAME_OPTIONS.map((option) => option.value) as [
					(typeof ROUTINE_TEST_NAME_OPTIONS)[number]['value'],
					...string[],
				],
			),
			nameOther: z.string().optional(),
			frequency: z.enum(
				TEST_FREQUENCY_OPTIONS.map((option) => option.value) as [
					(typeof TEST_FREQUENCY_OPTIONS)[number]['value'],
					...string[],
				],
			),
		}),
	)
	.superRefine((data, ctx) => {
		if (data.name === 'other' && !data.nameOther?.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Describe the test routine name.',
				path: ['nameOther'],
			})
		}
		if (!TEST_FREQUENCY_VALUE_SET.has(data.frequency)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Select the testing cadence.',
				path: ['frequency'],
			})
		}
	})

export type TestRoutineEntry = z.infer<typeof TestRoutineEntrySchema>
